<template>
  <div class="flex flex-col">
    <h2 class="font-bold uppercase ml-4 md:ml-4 mb-3">Projects</h2>

    <div class="flex flex-col bg-lightgray-lightest w-full md:px-4">
      <div class="flex md:flex-col justify-between items-center">
        <div class="size-adjustment relative w-1/2 h-full">
          <doughnut
            class="size-adjustment w-full p-4 pt-6"
            :chart-data="chartData"
            :options="chartOptions"
          />
          <div
            class="total-projects-center absolute flex flex-col justify-center items-center"
          >
            <p class="text-5xl font-bold leading-none">{{ totalProjects }}</p>
            <p class="uppercase font-bold">total</p>
          </div>
        </div>
        <custom-doughnut-legend class="h-full" :legend-data="chartData" />
      </div>

      <div class="p-4">
        <router-link
          class="button ghost no-min-width w-full uppercase"
          tag="button"
          :to="{ name: 'projects' }"
        >
          Show Projects
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Doughnut from "../../elements/charts/Doughnut";
import CustomDoughnutLegend from "../../elements/charts/CustomDoughnutLegend";
import { colors } from "../../../bdg-shared-assets/tailwind-theme/colors";

export default {
  name: "ProjectsOverviewModule",
  components: { CustomDoughnutLegend, Doughnut },
  data() {
    return {
      chartOptions: {
        cutoutPercentage: 70,
        legend: {
          display: false
        }
      }
    };
  },
  computed: {
    projectsIndexTabs() {
      return this.$store.state.Projects.indexTabs;
    },
    projectCounts() {
      if (this.projectsIndexTabs) {
        return this.projectsIndexTabs.reduce((acc, tab) => {
          return {
            ...acc,
            [tab.slug]: tab.count
          };
        }, {});
      }
      return {};
    },
    totalProjects() {
      return Object.values(this.projectCounts).reduce((a, b) => a + b, 0);
    },
    chartData() {
      return {
        datasets: [
          {
            data: Object.values(this.projectCounts),
            backgroundColor: Object.values(colors.red).reverse(),
            borderWidth: 0
          }
        ],
        labels: Object.keys(this.projectCounts)
      };
    }
  },
  created() {
    this.$store.dispatch("getProjects");
  }
};
</script>

<style lang="scss" scoped>
.total-projects-center {
  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);
}

.size-adjustment {
  min-width: 195px;
}
</style>
